import React from 'react';
import "./CustomizePopup.css";
import { useNavigate } from 'react-router-dom';
import { KTIcon } from '../_metronic/helpers';
import { useAppDispatch } from '../app/hooks';
import { UpdateCurrentPopupId } from './GlobalSlice';
import { getValueFromResource } from './timeLiveFunction';
import { t } from 'i18next';

type PopupMenuProps = {
  onClose: () => void;
  isOpen: boolean;
  top: number;
  left: number;
  children: React.ReactNode;
  isActive: any;
  popupHeading: string;
};

const CustomizePopup: React.FC<PopupMenuProps> = ({ onClose, isOpen, top, left, children, isActive, popupHeading }) => {
  const navigate = useNavigate();
const dispatch = useAppDispatch();
  if (!isOpen) return null;

  const handleNavigate =(value: any)=>{
    navigate(value);
    dispatch(UpdateCurrentPopupId(null));
  }
  let popupData = [];
  if( Array.isArray(children)){
    popupData = children.filter((item)=> item !== false);
  }
  return (
    <div
      className="popup-overlay"
      onClick={onClose}
    >
      <div
        className="popup-content"
        onClick={(e) => e.stopPropagation()}
        style={{ position: 'absolute', top: `${top - 30}px`, left: `${left}px` }}
      >
        <h3 className="card-title fw-bold headerTitle">{getValueFromResource(popupHeading, dispatch, t)}</h3>
        {Array.isArray(popupData) && popupData.map((item: any, ind: any) => {
          const iconName= item?.props?.icon;
          return (
            <div className='row' style={{ marginTop: "5%" }}>
              <div className="col-sm-2">
                
                  {iconName ? (<span className='menu-icon'>
                    {' '}
                    <KTIcon iconName={iconName} className='fs-2 text-gray-600' />
                  </span>) : (
                    <i className="bi bi-dot fs-3 text-gray-600" style={{ cursor: "pointer" }}></i>
                  )}
                
              </div>
              <div className='col-sm-9'>
                <span className="list" style={{ cursor: "pointer" }} onClick={() => handleNavigate(`${item.props.to}`)}>{getValueFromResource(item?.props?.title, dispatch, t)}</span>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  );
};

export default CustomizePopup;
